import './CreateMission.scss';

import { CalendarMonth, PersonAddAlt1Outlined } from '@mui/icons-material';
import { Button, Switch } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import RegimeModeTravail from '../../../Components/shared/RegimeModeTravail';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchCity from '../../../Components/shared/SearchCity';
import SearchEntreprise from '../../../Components/shared/SearchEntreprise';
import SearchUser from '../../../Components/shared/SearchUser';
import SelectRadioBtn from '../../../Components/shared/SelectGender';
import { dureeBdcEnum, sourceMissionEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDateRangeValidator from '../../../hooks/useDateRangeValidator';
import useFormValidation from '../../../hooks/useFormValidation';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { calculateWorkingDaysBetweenDates, searchLabelInEnumByValue } from '../../../Utils/utils';
import { getCommissionHTH, getPaymentSimulationResults } from '../../../Utils/utilsCraX';
const adaptAOListToSelect = (AosRetenu) => {
    if (Array.isArray(AosRetenu)) {
        return AosRetenu.map((ao) => {
            return {
                label: ao?.intitulePoste + ' #' + ao?.aoId,
                value: ao
            };
        });
    }
    else return [];
};
const adaptDossierListToSelect = (dossierRetenu) => {
    if (Array.isArray(dossierRetenu)) {
        return dossierRetenu.map((dossier) => {
            return {
                label: dossier?.nom + ' #' + dossier?.dossierId,
                value: dossier
            };
        });
    }
    else return [];
};

export const MISSION_COMPONENT_TYPES_ENUM = {
    create: 'create',
    modify: 'modify',
    renew: 'renew'
};

const getSourceMissionObject = (source, selectedJob) => {
    if (source == 'ao') {
        return {aoId:selectedJob?._id };
    }
    else if (source == 'cvtheque') {
        return {dossierId:selectedJob?._id };
    }

};
const getTitrePageMission = (mission_component_type) => {
    if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create)
        return {titre: 'Créer une mission', button: 'Créer' };
    else if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew)
        return {titre: 'Renouvellement', button: 'Renouveler Mission'};
    else if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.modify)
        return {titre: 'Modification', button: 'Modifier'};
};

function CreateMission({ mission_component_type }) {
    CreateMission.propTypes = { mission_component_type: PropTypes.any, };
    const { missionId } = useParams();
    const navigate = useNavigate();
    const [missionType,setMissionType]=useState('');
    const [missionActor,setMissionActor]=useState('');
    const axiosPrivate = useAxiosPrivate();
    const { setShowErrors, setErrors} = useUtilities();
    const {device}=useWindowSize();
    // * create
    // TODO: search only experts that had postulate to this offer
    const [expert, setExpert] = useState();
    const [client, setClient] = useState();
    // const [esn, setEsn] = useState();
    const [expertsWithRetainedCandidatures, setExpertsWithRetainedCandidatures] = useState([]);
    const [esnName,setEsnName]=useState();
    const [esnRef,setEsnRef]=useState();
    const [esnId,setEsnId]=useState();
    const [chargeRecrutement, setChargeRecrutement] = useState();
    const [responsableAchat, setResponsableAchat] = useState();
    const [responsableOperationnel, setResponsableOperationnel] = useState();
    const [responsableComptabilite, setResponsableComptabilite] = useState();
    const [collaboratorEsnExpertId, setCollaboratorEsnExpertId] = useState();
    const [responsableComptabiliteEsnExpertId, setResponsableComptabiliteEsnExpertId] = useState();
    const [sourceMission, setSourceMission] = useState();
    // const [jobSource, setJobSource] = useState({
    //     aoId: null,
    //     dossierId: null
    // });
    const [jobsRetenu, setJobsRetenu] = useState([]);
    const [selectedJob, setSelectedJob] = useState();
    const [dateDebutMission, setDateDebutMission] = useState();
    const [dateFinMission, setDateFinMission] = useState();
    const [dateDebutBDC, setDateDebutBDC] = useState();
    const [dateFinBDC, setDateFinBDC] = useState();
    const [localisation, setLocalisation] = useState('');
    const [differentLinkChargeRecrutement,setDifferentLinkChargeRecrutement]=useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [commission, setCommission] = useState();
    const { i18n } = useTranslation();
    const [modeTravail, setModeTravail] = useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });
    // ! there is a lot of todos on creation of Mission, but I will move now the the bdc process = proposition commerciale + ordre de mission after mission creation
    const [createdMission, setCreatedMission] = useState({
        titre: '',
        dureeMission: null,
        // *BDC
        nbJoursBDC: null,
        tj: null,
        tjClient: null,
        frequenceRenouv: null,
        refCmdClient: null,
    });
    // * renew
    const [selectedMission, setSelectedMission] = useState(null);

    const [isValid] = useFormValidation([

        { name: 'client', value: client },
        { name: 'expert', value: expert },
        { name: 'sourceMission', value: sourceMission },
        { name: 'selectedJob', value: selectedJob },

        { name: 'dateDebutMission', value: dateDebutMission },
        { name: 'dateFinMission', value: dateFinMission },
        { name: 'dateDebutBDC', value: dateDebutBDC },
        { name: 'dateFinBDC', value: dateFinBDC },
        { name: 'localisation', value: localisation },
        { name: 'modeTravail', value: modeTravail?.type },
        { name: 'regimeTravail', value: regimeTravail?.type },

        { name: 'titre', value: createdMission.titre },
        // { name: 'createdMission.dureeMission', value: createdMission.dureeMission },
        { name: 'createdMission.nbJoursBDC', value: createdMission.nbJoursBDC },
        // { name: 'createdMission?.frequenceRenouv', value: createdMission?.frequenceRenouv },
        { name: 'createdMission.tj', value: createdMission.tj },
        { name: 'createdMission.tjClient', value: createdMission.tjClient },

        { name: 'chargeRecrutement', value: chargeRecrutement },
        // { name: 'responsableOperationnel', value: responsableOperationnel },
        // { name: 'responsableAchat', value: responsableAchat },
        // { name: 'responsableComptabilite', value: responsableComptabilite },
    ]);
    const [isValidRangeDateBDC, messageRangeDateBDC] = useDateRangeValidator(dateDebutBDC, dateFinBDC);
    const [isValidRangeDateMission, messageRangeDateMission] = useDateRangeValidator(dateDebutMission, dateFinMission);
    const [isMissionShouldNotBeInitialized, setIsMissionShouldNotBeInitialized] = useState(true);
    const [isMissionHasLessThanTwoBdcOrCra, setIsMissionHasLessThanTwoBdcOrCra] = useState(false);

    useEffect(() => {
        if(missionId)
            getMissionbyId();
    }, [missionId]);

    useEffect(() => {
        getMyInfos();
    }, []);

    const getRoleBasedOnMission = (missionAct) => {
        if (missionAct === 'client') {
            return 'Client';
        } else
            return 'Esn';
    };

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setDifferentLinkChargeRecrutement(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (client) {
            setChargeRecrutement(client?.backOfficeId);
            if (sourceMission == 'ao') {
                getAOsByClientId();
            }
            else if (sourceMission == 'cvtheque' && missionActor) {
                getDossierByClientId();
            }
        }
        else {
            setSelectedJob(null);
        }
    }, [client, sourceMission,missionActor]);

    // //si la source change, tous les champs doivent être réinitialisés
    // useEffect(() => {
    //     if (sourceMission) {
    //         setSelectedJob(null);
    //     }
    // }, [sourceMission]);
    // calculate duree mission
    useEffect(() => {
        if (dateDebutMission !== null && dateFinMission !== null) {
            setCreatedMission({
                ...createdMission,
                ['dureeMission']: calculateWorkingDaysBetweenDates(dateDebutMission, dateFinMission),
            });
        }
    }, [dateDebutMission, dateFinMission]);

    // calculate duree BDC
    useEffect(() => {
        if (dateDebutBDC !== null && dateFinBDC !== null) {
            setCreatedMission({
                ...createdMission,
                ['nbJoursBDC']: calculateWorkingDaysBetweenDates(dateDebutBDC, dateFinBDC),
            });
        }
    }, [dateDebutBDC, dateFinBDC]);

    const getMissionbyId = async () => {
        try {
            const response = await axiosPrivate.get(`/mission/getMissionbyId/${missionId}`
            );
            console.log(response?.data);
            setSelectedMission(response?.data?.mission);
            const lastBDC = response?.data?.mission?.BDCs[response?.data?.mission?.BDCs.length - 1];
            setClient(response?.data?.mission?.companyDataId ?? response?.data?.mission?.esnId);
            setExpert(response?.data?.mission?.expertId);

            setSelectedJob(response?.data?.mission?.aoId?? response?.data?.mission?.dossierId);
            setSourceMission(response?.data?.mission?.sourceMission);
            setCreatedMission({
                ...createdMission,
                nbJoursBDC: lastBDC?.nbJoursBDC,
                tj: lastBDC?.tj,
                tjClient: lastBDC?.tjClient,
                refCmdClient: lastBDC?.refCmdClient,
                frequenceRenouv: lastBDC?.frequenceRenouv,

                titre: response?.data?.mission?.titre,
                dureeMission: response?.data?.mission?.dureeMission,
            });

            setDateDebutMission(moment(response?.data?.mission?.dateDebutMission));
            setDateFinMission(moment(response?.data?.mission?.dateFinMission));
            setLocalisation(response?.data?.mission?.localisation);
            setRegimeTravail(lastBDC?.regimeTravail);
            setModeTravail(lastBDC?.modeTravail);
            setChargeRecrutement(lastBDC?.backOfficeId),

            setResponsableAchat(lastBDC?.responsableAchatId ?? lastBDC?.responsableAchatEsnId),
            setResponsableOperationnel(lastBDC?.responsableOperationnelId ?? lastBDC?.responsableOperationnelEsnId),
            setResponsableComptabiliteEsnExpertId(lastBDC?.responsableComptabiliteEsnExpertId),
            setCollaboratorEsnExpertId(lastBDC?.collaboratorEsnExpertId),
            setResponsableComptabilite(lastBDC?.responsableComptabiliteId ?? lastBDC?.responsableComptabiliteEsnId);
            if(response?.data?.mission?.esnExpertOwnerId){
                setMissionType('achat');
                setEsnName(response?.data?.mission?.esnExpertOwnerId?.profileEntreprise?.nom);
                setEsnRef(response?.data?.mission?.esnExpertOwnerId?.esnId);
                setEsnId(response?.data?.mission?.esnExpertOwnerId?._id);
            }
            else
                setMissionType('vente');
            if(response?.data?.mission?.esnId)
                setMissionActor('esn');
            else
                setMissionActor('client');
            if(mission_component_type == MISSION_COMPONENT_TYPES_ENUM.modify){
                setDateDebutBDC(moment(lastBDC?.dateDebutBDC));
                setDateFinBDC(moment(lastBDC?.dateFinBDC));
                if(response?.data?.mission?.BDCs.length <2 && response?.data?.mission.BDCs.reduce((total, bdc) => total + bdc.CRAs.length, 0) < 2){
                    setIsMissionHasLessThanTwoBdcOrCra(true);
                }
            }
            else if(mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew){
                setDateDebutBDC(moment(lastBDC?.dateFinBDC).add(1, 'day'));
                setDateFinBDC(moment(lastBDC?.dateFinBDC).add(1, 'day').add(Number(lastBDC?.frequenceRenouv),'M'));
            }
        } catch (error) {
            console.log(error);
        }
    };

    // ! from old renouveler
    const renouvelerBDC = async () => {
        console.log({  chargeRecrutement,responsableAchat,responsableOperationnel,responsableComptabilite });
        try {
            let payload = {
                missionId,
                chargeRecrutementId: chargeRecrutement?._id??chargeRecrutement,
                createdBDC: createdMission,
                dateFinBDC,
                dateDebutBDC,
                modeTravail,
                regimeTravail
            };

            if (missionActor === 'esn') {
                if (missionType === 'achat') {
                    payload = {
                        ...payload,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatEsnId,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelEsnId,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnId,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnExpertId,
                    };
                } else if (missionType === 'vente') {
                    payload = {
                        ...payload,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatEsnId,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelEsnId,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnId,
                    };
                }
            } else {
                if (missionType === 'achat') {
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        responsableAchatId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatId,
                        responsableOperationnelId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelId,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteId,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnExpertId,
                    };
                }
                else{
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        responsableAchatId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatId,
                        responsableOperationnelId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelId,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite ??selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteId,
                    };
                }
            }

            const response = await axiosPrivate.post(
                'mission/renouvelerBDC',payload
            );
            const responseData1 = await response.data;
            Swal.fire({
                icon: 'success',
                // title: 'Created',
                text: i18n.t(responseData1.message),
                confirmButtonText: 'OK',
                confirmButtonColor: '#5CC889',
            });
            if(differentLinkChargeRecrutement)
                navigate('/admin');
            else
                navigate('/admin/mission');
        } catch (error) {
            console.log(error, error?.response);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: i18n.t(error?.response?.data?.error),
            });
        }
    };
    const handleInputChange = (tj,tjClient) => {
        const calculatedResult = getCommissionHTH({ tj: tj, tjClient: tjClient });
        if (12 > calculatedResult) {
            setErrorMessage('Le taux de commission ne peut pas être inférieure à 12%');
            setIsButtonDisabled(true);
        } else {
            setErrorMessage('');
            setIsButtonDisabled(false);
        }
        setCommission(calculatedResult);
    };

    const handleChange = (prop) => (event) => {
        const updatedValue = event.target.value;
        setCreatedMission((prevState) => ({
            ...prevState,
            [prop]: updatedValue,
        }));
        if (prop === 'tjClient' ) {
            // Call handleInputChange with the updated value
            handleInputChange(createdMission.tj,updatedValue);
        }
        if(prop === 'tj')
            handleInputChange(updatedValue,createdMission.tjClient);

    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    useEffect(() => {
        if(createdMission.tj && createdMission.tjClient)
            handleInputChange(createdMission.tj,createdMission.tjClient);
    }, [createdMission.tj,createdMission.tjClient]);

    const handleChangeJobSelected = (tempSelectedJob) => {
        setSelectedJob(tempSelectedJob);
        if (Array.isArray(tempSelectedJob?.candidatures)) {
            // let tempExpertsList = tempSelectedJob.candidatures?.map((candidature) => {
            //     let newObj = candidature.expertId;
            //     if(candidature.tj)
            //         newObj['tj'] = candidature.tj;
            //     return newObj;
            // });
            let tempExpertsList = tempSelectedJob?.candidatures?.map((candidature) => {
                if (missionType === 'achat' && (candidature?.esnExpertOwnerId ||candidature?.typeExpertEsn=='indep')) {
                    // Pour le cas d'achat, on retourne seulement les experts liees un ESN
                    // return candidature.expertId?.collaboratorEsnAttacherId;
                    let newObj = candidature?.expertId;
                    newObj['esnId']=candidature?.esnExpertOwnerId?.esnId;
                    newObj['esnName']=candidature?.esnExpertOwnerId?.profileEntreprise?.nom;
                    newObj['esnId_']=candidature?.esnExpertOwnerId?._id;
                    // newObj['email']=candidature?.esnExpertOwnerId?._id;
                    if(candidature.tj)
                        newObj['tj'] = candidature.tj;

                    return newObj;
                } else if (missionType === 'vente' && (!candidature?.esnExpertOwnerId || candidature?.typeExpertEsn=='salarie')) {
                    // Pour le cas de vente, on retourne les experts indépendants
                    let newObj = candidature.expertId;
                    if(candidature.tj)
                        newObj['tj'] = candidature.tj;
                    return newObj;
                    // return !candidature.expertId?.collaboratorEsnAttacherId;
                }
            });
            //let tempExpertsList = tempSelectedJob.candidatures?.map((candidature) => {candidature.expertId,'tj',candidature.tj});
            setExpertsWithRetainedCandidatures(tempExpertsList);
        }
        setCreatedMission({
            ...createdMission,
            ['titre']: tempSelectedJob?.intitulePoste ?? tempSelectedJob?.nom ,
            // TODO : change this value to the one specific for expert from candidature collection
            //['tjClient']: tempSelectedJob?.tjMax,
            ['nbJoursBDC']: tempSelectedJob?.dureeBDC,
            ['frequenceRenouv']: tempSelectedJob?.dureeBDC,
            ['dureeMission']: tempSelectedJob?.dureeMission,
            // ['nbJrsPartielPerWeek']: tempSelectedAo?.nbJrsPartielPerWeek,
            // ['regimeTravail']: tempSelectedAo?.regimeTravail,
            // ['responsableOperationnel']: tempSelectedAo?.entrepriseData?.managerProjet,
            // ['responsableAchat']: tempSelectedAo?.entrepriseData?.responsableAchat,
        });
        setRegimeTravail(tempSelectedJob?.regimeTravail);
        setModeTravail(tempSelectedJob?.modeTravail);
        if(tempSelectedJob?.dateDebutMission)
            setDateDebutMission(moment(tempSelectedJob?.dateDebutMission));
        if(tempSelectedJob?.dateDebutMission)
            setDateDebutBDC(moment(tempSelectedJob?.dateDebutMission));
        setLocalisation(tempSelectedJob?.localisation);
        if(tempSelectedJob?.dateDebutMission)
            setDateFinBDC(moment(tempSelectedJob?.dateDebutMission).add(Number(tempSelectedJob?.dureeBDC),'M'));
        //setDateFinBDC(moment(tempSelectedJob?.dateDebutMission).add(Number(tempSelectedJob?.dureeBDC),'M'));
        if(tempSelectedJob?.dateFinMission)
            setDateFinMission(moment(tempSelectedJob?.dateFinMission));
        setResponsableOperationnel(tempSelectedJob?.entrepriseData?.responsableOperationnelId ?? tempSelectedJob?.collaboratorId ?? tempSelectedJob?.entrepriseData?.responsableOperationnelEsnId);
        setResponsableComptabilite(tempSelectedJob?.entrepriseData?.responsableComptabiliteId ?? tempSelectedJob?.entrepriseData?.responsableComptabiliteEsnId);
        setResponsableAchat(tempSelectedJob?.entrepriseData?.responsableAchatId ?? tempSelectedJob?.entrepriseData?.responsableAchatEsnId);
    };
    const { setBackdropOpen } = useUtilities();
    const createMission = async () => {
        try {
            setBackdropOpen(true);
            const sourceJob = getSourceMissionObject(sourceMission, selectedJob);
            let payload = {
                ...sourceJob,
                createdMission,
                chargeRecrutementId: chargeRecrutement?._id ?? chargeRecrutement,
                dateDebutMission,
                dateFinMission,
                sourceMission,
                dateFinBDC,
                dateDebutBDC,
                localisation,
                modeTravail,
                regimeTravail,
                // * 4 Notif
                NomBesoin: selectedJob?.intitulePoste ?? selectedJob?.nom
            };

            // Handle condition for missionActor and missionType
            if (missionActor === 'esn') {
                if (missionType === 'achat') {
                    payload = {
                        ...payload,
                        esnExpertOwnerId: expert?.esnId_ ?? esnId,
                        expertId: expert?._id,
                        esnId: client?._id,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId,
                    };
                } else if (missionType === 'vente') {
                    payload = {
                        ...payload,
                        esnId: client?._id,
                        expertId: expert?._id,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite,
                    };
                }
            } else {
                if (missionType === 'achat') {
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        esnExpertOwnerId: expert?.esnId_ ?? esnId,
                        expertId:expert?._id,
                        companyId: client?._id, //c'est l'entreprise maintenent
                        responsableAchatId: responsableAchat?._id ?? responsableAchat ,
                        responsableOperationnelId: responsableOperationnel?._id ?? responsableOperationnel,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId,
                    };
                }
                else{
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        companyId: client?._id, //c'est l'entreprise maintenent
                        expertId: expert?._id,
                        responsableAchatId: responsableAchat?._id ?? responsableAchat,
                        responsableOperationnelId: responsableOperationnel?._id ?? responsableOperationnel,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite,
                    };
                }
            }
            // Send the POST request with the constructed payload
            const response = await axiosPrivate.post('mission/createMission', payload);

            // const response = await axiosPrivate.post(
            //     'mission/createMission',
            //     {
            //         ...sourceJob,
            //         ...{ createdMission,
            //             expertId: expert?._id,
            //             esnExpertOwnerId:(missionActor=='esn' && missionType=='achat')?expert?._id:'',
            //             companyId: client?._id, //c'est l'entreprise maintenent
            //             esnId:(missionActor=='esn' && missionType=='vente' )?client?._id:'',
            //             chargeRecrutementId: chargeRecrutement?._id??chargeRecrutement,

            //             responsableAchatId: responsableAchat?._id??responsableAchat,
            //             responsableOperationnelId: responsableOperationnel?._id??responsableOperationnel,
            //             responsableComptabiliteId: responsableComptabilite?._id??responsableComptabilite,

            //             responsableAchatEsnId:responsableAchat?._id??responsableAchat,
            //             responsableOperationnelEsnId:responsableOperationnel?._id??responsableOperationnel,
            //             responsableComptabiliteEsnId:responsableComptabilite?._id??responsableComptabilite,

            //             // * collabs dans le cas : esn vente (=expert)
            //             collaboratorEsnExpertId:collaboratorEsnExpertId?._id??collaboratorEsnExpertId,
            //             responsableComptabiliteEsnExpertId:responsableComptabiliteEsnExpertId?._id??responsableComptabiliteEsnExpertId,
            //             // * collabs dans le cas : esn achat (=client)
            //             responsableAchatEsnId:responsableAchat?._id??responsableAchat,
            //             responsableOperationnelEsnId:responsableOperationnel?._id??responsableOperationnel,
            //             responsableComptabiliteEsnId:responsableComptabilite?._id??responsableComptabilite,

            //             dateDebutMission,
            //             dateFinMission,
            //             sourceMission,
            //             dateFinBDC,
            //             dateDebutBDC,
            //             localisation,
            //             modeTravail,
            //             regimeTravail,
            //             // * 4 Notif
            //             NomBesoin: selectedJob?.intitulePoste ?? selectedJob?.nom
            //         }
            //     });
            const responseData1 = await response.data;
            console.log(response.data);
            setBackdropOpen(false);
            Swal.fire({
                icon: 'success',
                // title: 'Created',
                text: i18n.t(responseData1.message),
                confirmButtonText: 'OK',
                confirmButtonColor: '#5CC889',
            });
            if(differentLinkChargeRecrutement)
                navigate('/admin');
            else
                navigate('/admin/mission');
        } catch (error) {
            console.log(error, error?.response?.status);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error?.response?.data?.error,
            });
        }
    };

    const updateMission = async () => {
        try {
            setBackdropOpen(true);
            let payload = {
                missionId,
                bdcId: selectedMission?.BDCs[selectedMission?.BDCs.length - 1],
                createdMission,
                chargeRecrutementId: chargeRecrutement?._id??chargeRecrutement,
                dateDebutMission,
                dateFinMission,
                dateFinBDC,
                dateDebutBDC,
                localisation,
                modeTravail,
                regimeTravail,
                isMissionShouldNotBeInitialized
            };
            if (missionActor === 'esn') {
                if (missionType === 'achat') {
                    payload = {
                        ...payload,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatEsnId,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelEsnId,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnId,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnExpertId,
                    };
                } else if (missionType === 'vente') {
                    payload = {
                        ...payload,
                        responsableAchatEsnId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatEsnId,
                        responsableOperationnelEsnId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelEsnId,
                        responsableComptabiliteEsnId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnId,
                    };
                }
            } else {
                if (missionType === 'achat') {
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        responsableAchatId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatId,
                        responsableOperationnelId: responsableOperationnel?._id ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelId,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteId,
                        collaboratorEsnExpertId: collaboratorEsnExpertId?._id ?? collaboratorEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.collaboratorEsnExpertId,
                        responsableComptabiliteEsnExpertId: responsableComptabiliteEsnExpertId?._id ?? responsableComptabiliteEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnExpertId,
                    };
                }
                else{
                    // Default case when missionActor is not 'esn'
                    payload = {
                        ...payload,
                        responsableAchatId: responsableAchat?._id ?? responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatId,
                        responsableOperationnelId: responsableOperationnel?._id ?? responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelId,
                        responsableComptabiliteId: responsableComptabilite?._id ?? responsableComptabilite ?? responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteId,
                    };
                }
            }

            const response = await axiosPrivate.put(
                'mission/updateMission',payload);
                // {
                //     missionId,
                //     bdcId: selectedMission?.BDCs[selectedMission?.BDCs.length - 1],
                //     createdMission,
                //     chargeRecrutementId: chargeRecrutement?._id??chargeRecrutement,
                //     responsableAchatId: responsableAchat?._id??responsableAchat,
                //     responsableOperationnelId: responsableOperationnel?._id??responsableOperationnel,
                //     responsableComptabiliteId: responsableComptabilite?._id??responsableComptabilite,

            //     dateDebutMission,
            //     dateFinMission,
            //     dateFinBDC,
            //     dateDebutBDC,
            //     localisation,
            //     modeTravail,
            //     regimeTravail,
            //     isMissionShouldNotBeInitialized
            // }
            const responseData1 = await response.data;
            console.log(response.data);

            setBackdropOpen(false);
            Swal.fire({
                icon: 'success',
                // title: 'Created',
                text: responseData1.message,
                confirmButtonText: 'OK',
                confirmButtonColor: '#5CC889',
            });
            if(differentLinkChargeRecrutement)
                navigate('/admin');
            else
                navigate('/admin/mission');
        } catch (error) {
            console.log(error, error?.response?.status);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error?.response?.data?.error,
            });
        }
    };

    const getAOsByClientId = async () => {
        try {
            const response = await axiosPrivate.get('/ao/getAOsByClientId/' + client?._id );
            setJobsRetenu(adaptAOListToSelect(response?.data?.AOs));
            setExpertsWithRetainedCandidatures([]); //pour vider la liste des experts
        } catch (error) {
            console.warn(error);
            setJobsRetenu(null); // Set to null in case of error
            setExpert(null);
            setExpertsWithRetainedCandidatures([]);
        }
    };

    const getDossierByClientId = async () => {
        try {
            const response = await axiosPrivate.get(
                '/cvTheque/getDossierByClientId/' + client?._id +
                '?isEsn=' + ((missionActor === 'esn') ? true : false)
            );
            setJobsRetenu(adaptDossierListToSelect(response?.data));
            setExpertsWithRetainedCandidatures([]); //pour vider la liste des experts

        } catch (error) {
            console.warn(error);
            setJobsRetenu(null); // Set to null in case of error
            setExpert(null);
            setExpertsWithRetainedCandidatures([]);
        }
    };

    useEffect(() => {
        if(expert){
            setCreatedMission({
                ...createdMission,
                ['tj']: expert?.tj || expert?.preference?.tjm,
                ['tjClient']: getPaymentSimulationResults({tj:(expert?.tj || expert?.preference?.tjm), commissionHTH:0.2})?.tjClient,
            });

        }
    }, [expert]);

    return (
        <form
            style={{ fontFamily: 'Lato',display:'flex',alignSelf:'stretch',maxWidth:'1600px',flexDirection:'column',gap:'24px' }}
        >
            <div className='frame5Profile'>
                {i18n.t('Gestion des missions')} &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                    {i18n.t('Missions')}
                </span>
            </div>
            <div className='createmission'>
                <h4 className='titlesociete'>
                    {i18n.t(getTitrePageMission(mission_component_type).titre)}
                </h4>
            </div>
            <div className='frame1'>
                <div className='frame11'>
                    <h6>{i18n.t('Informations mission')}</h6>
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Type de l\'Expert')}</p>
                            <SelectRadioBtn
                                value={missionType}
                                setValue={setMissionType}
                                name="type"
                                options={[
                                    { label: 'Indépendant (pour Vente)', optionValue: 'vente' },
                                    { label: 'ESN (pour achat)', optionValue: 'achat' }
                                ]}
                                disabled={mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ?false:true}
                                // setCheckUpdateValue={setWasValuesUpdated}
                            />
                        </div>
                        {/* {missionType=='vente' && */}
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Type du client')}</p>
                            <SelectRadioBtn
                                value={missionActor}
                                setValue={setMissionActor}
                                name="missionActor"
                                options={[
                                    { label: 'Esn', optionValue: 'esn' },
                                    { label: 'Client', optionValue: 'client' }
                                ]}
                                disabled={mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ? false:true}
                                // setCheckUpdateValue={setWasValuesUpdated}
                            />
                        </div>
                        {/* } */}
                    </div>
                    <div className='row1'>

                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nom du client')}</p>
                            {mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ?
                                <SearchEntreprise
                                    width={'100%'}
                                    setClient={setClient}
                                    name={missionActor}
                                />:
                                <TextFieldComponent
                                    variant='outlined'
                                    sx={{ width: '100%',
                                        '& > :not(style)': {borderRadius: '8px'}
                                    }}
                                    id="outlined-name"
                                    value={selectedMission?.companyDataId?.profileEntreprise?.nom ?? selectedMission?.esnId?.profileEntreprise?.nom}
                                    disabled
                                />}
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Réf. client')}</p>
                            <TextFieldComponent
                                variant='outlined'
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                style={{borderRadius:'8px'}}
                                id="outlined-name"
                                placeholder={i18n.t('Réf. Client')}
                                value={client?.clientId ?? client?.esnId ?? selectedMission?.companyDataId?.clientId ?? selectedMission?.esnId?.esnId}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="row1">
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Source')}</p>
                            {mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ?
                                <SelectComponent
                                    val={sourceMission}
                                    name='sourceMission'
                                    setVal={(e) => setSourceMission(e.target.value)}
                                    listVal={sourceMissionEnum}
                                /> :
                                <TextFieldComponent
                                    variant='outlined'
                                    sx={{ width: '100%',
                                        '& > :not(style)': {borderRadius: '8px'}
                                    }}
                                    id="outlined-name"
                                    value={i18n.t(searchLabelInEnumByValue(sourceMissionEnum,selectedMission?.sourceMission))}
                                    disabled
                                />
                            }
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Réf. AO ou CVThèque')}</p>
                            {mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ?
                                <SelectComponent
                                    val={selectedJob}
                                    name='selectedJob'
                                    setVal={(e) => {
                                        handleChangeJobSelected(e.target?.value);
                                    }
                                    }
                                    listVal={jobsRetenu}
                                />:
                                <TextFieldComponent
                                    variant='outlined'
                                    sx={{ width: '100%',
                                        '& > :not(style)': {borderRadius: '8px'}
                                    }}
                                    id="outlined-name"
                                    value={selectedMission?.aoId?.aoId ?? selectedMission?.dossierId?.dossierId}
                                    disabled
                                />
                            }
                        </div>
                    </div>
                    <div className='row1' >
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Intitulé de la mission')}</p>
                            <TextFieldComponent
                                style={{ width: '100%'}}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                type="text"
                                name="titre"
                                autoComplete="off"
                                placeholder="Intitulé de la mission"
                                defaultValue={selectedJob?.intitulePoste || selectedJob?.nom}
                                value={createdMission.titre || selectedMission?.titre}
                                onChange={handleChange('titre')}
                                disabled={mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew}
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nombre de poste')}</p>
                            <IconTextField
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                id="outlined-name"
                                type='number'
                                onKeyDown={handleKeyDown}
                                value={selectedJob?.nbRecrutes ?? selectedMission?.aoId?.nbRecrutes}
                                iconStart={<PersonAddAlt1Outlined />}
                                InputProps={{
                                    inputProps: { min: 1},
                                    //startAdornment: (
                                    //    <div className='iconStyleStartAdornment'>
                                    //        <InputAdornment position="start"><PersonAddAlt1Outlined /></InputAdornment>
                                    //    </div>),

                                }}
                                disabled
                            />
                        </div>
                    </div>

                    <div className='row1' >
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nom de l\'expert')}</p>
                            {mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create ?
                                <SearchUser
                                    width={'100%'}
                                    // userType={getRoleBasedOnMission(missionType, missionActor)}
                                    userType='Expert'
                                    setUser={setExpert}
                                    user={expert}
                                    selectedAoId={selectedJob?._id}
                                    expertsWithRetainedCandidatures={expertsWithRetainedCandidatures}
                                    name='expert'
                                />:
                                <TextFieldComponent
                                    variant='outlined'
                                    sx={{ width: '100%',
                                        '& > :not(style)': {borderRadius: '8px'}
                                    }}
                                    id="outlined-name"
                                    value={selectedMission?.expertId?.persoData?.nom +' '+ selectedMission?.expertId?.persoData?.prenom}
                                    disabled
                                />
                            }
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Réf. expert')}</p>
                            <TextFieldComponent
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                id="outlined-name"
                                placeholder="Réf. expert"
                                value={expert?.expertId ?? selectedMission?.expertId?.expertId}
                                disabled
                            />
                        </div>
                    </div>
                    {missionType=='achat' &&
                    <div className='row1' >
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nom Esn')}</p>

                            <TextFieldComponent
                                variant='outlined'
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                id="outlined-name"
                                value={expert?.esnName ?? esnName}
                                disabled
                            />

                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Réf. esn')}</p>
                            <TextFieldComponent
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                id="outlined-name"
                                placeholder="Réf. esn"
                                value={esnRef ?? expert?.esnId }
                                disabled
                            />
                        </div>
                    </div>
                    }
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Date de début/mission')}</p>
                            <DatePickerComponent
                                label=""
                                date={dateDebutMission ?? selectedMission?.dateDebutMission}
                                name='dateDebutMission'
                                setDate={(newValue) => {
                                    setDateDebutMission(newValue);
                                }}
                                width={'100%'}
                                disabled={mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew}
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Date de fin/mission')}</p>
                            <DatePickerComponent
                                label=""
                                date={dateFinMission ?? selectedMission?.dateFinMission}
                                name='dateFinMission'
                                setDate={(newValue) => {
                                    setDateFinMission(newValue);
                                }}
                                width={'100%'}
                                disabled={mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew}

                                error={isValidRangeDateMission && !!messageRangeDateMission}
                                helperText={isValidRangeDateMission ? messageRangeDateMission : null}
                            />
                        </div>
                    </div>
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nombre de jours')}</p>
                            <IconTextField
                                id="outlined-start-adornment"
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                iconStart={<CalendarMonth />}
                                //InputProps={{
                                //    startAdornment: (
                                //        <div className='iconStyleStartAdornment'>
                                //            <InputAdornment position="start"><CalendarMonth /></InputAdornment>
                                //        </div>
                                //    ),
                                //}}
                                type="number"
                                // name="createdMission.dureeMission"
                                value={createdMission.dureeMission} // 4 renew was: calculateWorkingDaysBetweenDates(selectedMission?.dateDebutMission, selectedMission?.dateFinMission)
                                disabled
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Lieu')} </p>
                            {(mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create || mission_component_type == MISSION_COMPONENT_TYPES_ENUM.modify) ?
                                <SearchCity
                                    name='localisation'
                                    setCity={setLocalisation}
                                    city={localisation}
                                    //label=''
                                    width={'100%'}
                                />:
                                <TextFieldComponent
                                    variant='outlined'
                                    sx={{ width: '100%',
                                        '& > :not(style)': {borderRadius: '8px'}
                                    }}
                                    id="outlined-name"
                                    value={selectedMission?.localisation}
                                    disabled
                                />
                            }
                        </div>
                    </div>
                </div>
                <div className='frame11'>
                    <h6>{i18n.t('Personnel en charge de la mission')}</h6>
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Chargé de recrutement')}</p>
                            <SearchUser
                                width={'100%'}
                                userType={'BackOffice'}
                                setUser={setChargeRecrutement}
                                // user={chargeRecrutement}
                                // TODO: est ce que on peut selectionner un autre chargee de recrutement que celle liee au client dans la creation de mission ?
                                // companyId={client?._id}

                                userId={chargeRecrutement ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.backOfficeId}
                                name='chargeRecrutement'
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Responsable achat')}</p>
                            <SearchUser
                                width={'100%'}
                                userType={getRoleBasedOnMission(missionActor)}
                                setUser={setResponsableAchat}

                                // Send esnId if missionActor is 'esn', otherwise send companyId
                                esnId={missionActor === 'esn' ? (client?._id ?? selectedMission?.esnId) : undefined}
                                companyId={missionActor !== 'esn' ? (client?._id ?? selectedMission?.companyDataId?._id) : undefined}
                                //* form createAO
                                // placeholder={'Choisir...'}
                                // // userId={responsableAchat?._id??responsableAchat}
                                userId={responsableAchat ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableAchatEsnId}
                                name='responsableAchat'
                            />
                        </div>
                    </div>
                    {missionActor &&
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Responsable Opérationnel')}</p>
                            <SearchUser
                                width={'100%'}
                                userType={getRoleBasedOnMission(missionActor)}
                                setUser={setResponsableOperationnel}
                                // user={responsableOperationnel}

                                // Send esnId if missionActor is 'esn', otherwise send companyId
                                esnId={missionActor === 'esn' ? (client?._id ?? selectedMission?.esnId) : undefined}
                                companyId={missionActor !== 'esn' ? (client?._id ?? selectedMission?.companyDataId?._id) : undefined}
                                userId={responsableOperationnel ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableOperationnelEsnId}
                                name='responsableOperationnel'
                            />
                        </div>

                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Responsable Comptabilité')}</p>
                            <SearchUser
                                width={'100%'}
                                userType={getRoleBasedOnMission(missionActor)}
                                setUser={setResponsableComptabilite}
                                // Send esnId if missionActor is 'esn', otherwise send companyId
                                esnId={missionActor === 'esn' ? client?._id ?? selectedMission?.esnId : undefined}
                                companyId={missionActor !== 'esn' ? client?._id ?? selectedMission?.companyDataId?._id : undefined}
                                userId={responsableComptabilite ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnId}
                                name='responsableComptabilite'
                            />
                        </div>
                    </div>
                    }
                    {missionActor && missionType=='achat' &&
                        <div className='row1'>
                            <div className='insiderow1'>
                                <p style={{ margin: '0' }}>{i18n.t('Commercial /achat')}</p>
                                <SearchUser
                                    width={'100%'}
                                    userType='Esn'
                                    setUser={setCollaboratorEsnExpertId}
                                    // email={expert?.}
                                    // user={responsableOperationnel}
                                    esnId={expert?.esnId_ ?? esnId}
                                    userId={collaboratorEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.collaboratorEsnExpertId}
                                    name='collaboratorEsnExpertId'
                                />
                            </div>
                            <div className='insiderow1'>
                                <p style={{ margin: '0' }}>{i18n.t('Responsable Comptabilité /achat')}</p>
                                <SearchUser
                                    width={'100%'}
                                    userType='Esn'
                                    setUser={setResponsableComptabiliteEsnExpertId}
                                    // companyId={expert?.esnId_ ?? esnId}
                                    // email={expert?.}
                                    esnId={expert?.esnId_ ?? esnId}
                                    userId={responsableComptabiliteEsnExpertId ?? selectedMission?.BDCs[selectedMission?.BDCs.length - 1]?.responsableComptabiliteEsnExpertId}
                                    name='responsableComptabiliteEsnExpertId'
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='frame11'>
                    <h6>{i18n.t('Informations BDC')}</h6>
                    <div className='row1'>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Date de début/BDC')}</p>
                            <DatePickerComponent
                                // label="Date de début/BDC "
                                date={dateDebutBDC ?? selectedMission?.dateDebutMission}
                                name='dateDebutBDC'
                                setDate={(newValue) => {
                                    setDateDebutBDC(newValue);
                                }}
                                width={'100%'}
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Date de fin/BDC')}</p>
                            <DatePickerComponent
                                date={dateFinBDC ??  moment(selectedMission?.dateDebutMission).add(selectedMission?.dureeMission, 'days')}
                                name='dateFinBDC'
                                setDate={(newValue) => {
                                    setDateFinBDC(newValue);
                                }}
                                width={'100%'}
                                error={isValidRangeDateBDC && !!messageRangeDateBDC}
                                helperText={isValidRangeDateBDC ? messageRangeDateBDC : null}

                            />
                        </div>
                    </div>
                    <div className="row1">
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Nombre de jours')}</p>
                            <IconTextField
                                //label="Durée du BDC"
                                id="outlined-start-adornment"
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                iconStart={<CalendarMonth />}
                                //InputProps={{
                                //    startAdornment: (
                                //        <div className='iconStyleStartAdornment'>
                                //            <InputAdornment position="start"><CalendarMonth /></InputAdornment>
                                //        </div>
                                //    ),
                                //}}
                                type="number"
                                name="createdMission.nbJoursBDC"
                                value={createdMission.nbJoursBDC}
                                onChange={handleChange('nbJoursBDC')}
                            // disabled
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Fréquence de renouv.')}</p>
                            <SelectComponent
                                // label={'Fréquence de renouv. (en jours)'}
                                val={Number(createdMission?.frequenceRenouv)}
                                name='createdMission?.frequenceRenouv'
                                setVal={handleChange('frequenceRenouv')}
                                listVal={dureeBdcEnum}
                            />
                        </div>
                    </div>
                    <div className='row1' >
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Taux journalier/expert')}</p>
                            <IconTextField
                                id="outlined-start-adornment"
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                iconEnd={'€'}
                                //InputProps={{
                                //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                //}}
                                type="number"
                                name="tj"
                                // * OLD TJ Method value={getTjExpert(createdMission.tj)}
                                value={createdMission.tj}
                                onChange={handleChange('tj')}
                                autoComplete="off"
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Taux journalier/client')}</p>
                            <IconTextField
                                //className='clo-6'
                                id="outlined-start-adornment"
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                iconEnd={'€'}
                                //InputProps={{
                                //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                //}}
                                type="number"
                                name="tjClient"
                                value={createdMission.tjClient}
                                onChange={handleChange('tjClient')}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className='row1' >
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Taux de commission')}</p>
                            <IconTextField
                                //className='clo-6'
                                id="outlined-start-adornment"
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                iconStart={'%'}
                                InputProps={{
                                    inputProps: { min: 0, max: 12 },
                                    //startAdornment: (
                                    //    <div className='iconStyleStartAdornment'>
                                    //        <InputAdornment position="start">
                                    //            %
                                    //        </InputAdornment>
                                    //    </div>)

                                    // inputProps: { min: 0, max: 1 }
                                }}
                                type="number"
                                name="commission"
                                value={commission}
                                error={errorMessage !== ''}
                                helperText={i18n.t(errorMessage)}
                                // * OLD commissionHTH
                                autoComplete="off"
                                disabled
                            />
                        </div>
                        <div className='insiderow1'>
                            <p style={{ margin: '0' }}>{i18n.t('Commande  Client N°')}</p>
                            <TextFieldComponent
                                //className='col-6'
                                sx={{ width: '100%',
                                    '& > :not(style)': {borderRadius: '8px'}
                                }}
                                id="outlined-name"
                                placeholder='Réf.Commande client'
                                value={createdMission.refCmdClient}
                                onChange={handleChange('refCmdClient')}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <RegimeModeTravail
                        //style={{ marginTop: '15px' }}
                        setModeTravail={setModeTravail}
                        setRegimeTravail={setRegimeTravail}
                        modeTravail={modeTravail}
                        regimeTravail={regimeTravail}
                        //TODO: required: done: add the values to the useFromValidation directly
                    />
                    {isMissionHasLessThanTwoBdcOrCra &&
                        <div className='frame6paracompte'>
                            <div>
                                <p className='titreframe6paracompte'>
                                    {i18n.t('Voulez-vous empêcher la réinitialisation de la mission ?')}
                                    <Switch
                                        {...{ inputProps: { 'aria-label': 'Size switch demo' } }}
                                        checked={isMissionShouldNotBeInitialized}
                                        onChange={(event)=>{
                                            setIsMissionShouldNotBeInitialized(event.target.checked);
                                        }}
                                    />
                                </p>
                            </div>
                        </div>
                    }
                </div>
                <div className='frame14'>
                    <Button
                        variant="text"
                        style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        {i18n.t('Annuler')}
                    </Button>
                    <Button
                        style={{...buttonStylesGreen(isButtonDisabled),...{width:device=='desktop'?'auto':'100%'}}} //...{width:'85px'}
                        variant="contained"
                        type="submit"
                        disabled={isButtonDisabled}
                        onClick={(e) => {
                            e.preventDefault();
                            if (isValid) {
                                if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.create)
                                    createMission();
                                else if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.renew)
                                    renouvelerBDC();
                                else if (mission_component_type == MISSION_COMPONENT_TYPES_ENUM.modify)
                                    updateMission();
                                setShowErrors(false);
                                setErrors({});
                            }
                            else setShowErrors(true);
                        }}
                    >
                        {i18n.t(getTitrePageMission(mission_component_type).button)}
                    </Button>
                </div>
            </div>
        </form>
    );
}

export default CreateMission;